import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Text } from '@gasbuddy/react-components';

import Button from '../button';

import styles from './styles.css';
import sharedStyles from '../../styles/shared.css';

export default function DeleteConfirmationModal({ show, deleteConfirmationMessage, onDeleteConfirm, deleteButtonText }) {
  return (
    <Modal
      forceIsShowing={show}
      title=""
      hideHeaderSeparator
      size="sm"
    >
      <Text className={sharedStyles.titleText} centered>
        {deleteConfirmationMessage}
      </Text>
      <div className={styles.confirmDeleteCTAContainer}>
        <Button tertiary wide onClick={onDeleteConfirm}>{deleteButtonText}</Button>
      </div>
    </Modal>
  );
}

DeleteConfirmationModal.propTypes = {
  show: PropTypes.bool,
  deleteConfirmationMessage: PropTypes.string.isRequired,
  onDeleteConfirm: PropTypes.func.isRequired,
  deleteButtonText: PropTypes.string,
};

DeleteConfirmationModal.defaultProps = {
  show: false,
  deleteButtonText: 'Are you sure you want to delete this?',
};
